export function getBaseCoinName(coinName: string | undefined | null): string {
  const normalized = String(coinName ?? "");
  const parts = normalized.split(".");
  return parts[0] ?? normalized;
}

export function isBtcBaseCoin(coinName: string | undefined | null): boolean {
  return getBaseCoinName(coinName).toUpperCase() == "BTC";
}

export function getDefaultAlgorithmFromMap(
  coinsMap: Map<string, string[]> | undefined
): string | undefined {
  if (!coinsMap || coinsMap.size == 0) return undefined;
  return coinsMap.keys().next().value;
}

export function getDefaultCoinByAlgorithmFromMap(
  coinsMap: Map<string, string[]> | undefined,
  algorithm: string | undefined
): string | undefined {
  if (!coinsMap || !algorithm) return undefined;
  const coins = coinsMap.get(algorithm);
  if (!coins || coins.length == 0) return algorithm;
  return coins[coins.length - 1];
}

export function getPrimaryCoinFromMap(
  coinsMap: Map<string, string[]> | undefined
): string | undefined {
  const defaultAlgorithm = getDefaultAlgorithmFromMap(coinsMap);
  return getDefaultCoinByAlgorithmFromMap(coinsMap, defaultAlgorithm);
}
